import React from 'react';

function InfoSection() {
  return (
    <section className="max-w-7xl mx-auto mt-20 px-4 py-16 border-t border-gray-300">
      {/* 상단 3개 박스 */}
      <div className="flex flex-col md:flex-row justify-between gap-6 mb-16">
        <div className="flex-1 bg-gray-200 p-8 flex flex-col items-center text-center">
          <h3 className="font-bold text-lg mb-2">100% 자연산</h3>
          <p className="text-sm">점진적이고 효과적인 도움</p>
        </div>
        <div className="flex-1 bg-gray-200 p-8 flex flex-col items-center text-center">
          <h3 className="font-bold text-lg mb-2">과학적 연구를 통한 제품</h3>
          <p className="text-sm">몸이 필요로 하는 최적의 영양 공급</p>
        </div>
        <div className="flex-1 bg-gray-200 p-8 flex flex-col items-center text-center">
          <h3 className="font-bold text-lg mb-2">보증된 품질</h3>
          <p className="text-sm">전제품의 품질과 지속된 생산을 보장</p>
        </div>
      </div>

      {/* 하단 2개 박스 */}
      <div className="flex flex-col md:flex-row justify-between gap-6">
        <div className="flex-1 border-4 border-gray-300 p-8 justify-center text-center items-center h-62">
          <h4 className="font-bold mb-4">
            천연의 건강 보조제에 대한 저희의 약속
          </h4>
          <p className="text-sm leading-relaxed whitespace-pre-line">
            저희는 자연이야말로 건강의 열쇠를 쥐고 있으며,{'\n'}
            저희의 제품들을 통해 최고의 영양제가 공급되길 기대한다고 생각합니다.
            {'\n\n'}
            저희는 전 제품에 대해 광범위한 연구조사와 공급망의 관리감독을 통해
            {'\n'}
            고객을 100% 만족시킬 수 있도록 하고자 합니다.
          </p>
        </div>
        <div className="flex-1 border-4 border-gray-300 p-8 justify-center text-center items-center h-62">
          <h4 className="font-bold mb-4">초록입 홍합은?</h4>
          <ul className="text-sm leading-relaxed list-disc list-inside text-center max-w-md mx-auto">
            <li>30가지 이상의 필수 지방산 조합과, 풍부한 GAGs</li>
            <li>각종 연결 조직과 관절 기능을 지원</li>
            <li>심장 및 호흡기 건강을 보조</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default InfoSection;
